import { styled, Button } from '@mui/material';

import type { ButtonProps } from '@mui/material';
import type { Theme } from '@mui/material';

export const AmexLoadingButton = styled(Button)<ButtonProps>(({ theme }: { theme: Theme }) => ({
	width: '100%',
	fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.default),
}));
